import './App.scss';
import 'react-tooltip/dist/react-tooltip.css';

function App(props) {
  return props.children;
}

export default App;
